import Axios from "axios";
import JWT from "jsonwebtoken";
import Config from "../../config";

const AtlasAPI = {
    // eslint-disable-next-line no-unused-vars,max-lines-per-function
    install(Vue) {
        const axiosBasicAuth = Axios.create({
            baseURL: Config.atlasAPI.baseURL,
            timeout: 0,
            headers: {
                "Content-Type": "application/json",
            },
            auth: {
                username: Config.atlasAPI.basicAuth.username,
                password: Config.atlasAPI.basicAuth.password,
            },
        });
        const axiosJWTAuth = Axios.create({
            baseURL: Config.atlasAPI.baseURL,
            timeout: 0,
            headers: {
                "Content-Type": "application/json",
            },
        });

        Vue.prototype.$atlasAPI = {};

        Vue.prototype.$atlasAPI.setToken = token => {
            axiosJWTAuth.defaults.headers["Authorization"] = `Bearer ${token}`;
        };

        Vue.prototype.$atlasAPI.register = user => axiosBasicAuth.post(`/users`, user);

        Vue.prototype.$atlasAPI.login = user => axiosBasicAuth.post(`/users/login`, user);

        Vue.prototype.$atlasAPI.decodeToken = () => {
            let decoded = { userId: 0 };
            const token = localStorage.getItem("token");
            if (token) {
                decoded = JWT.decode(token);
            }
            return decoded;
        };

        Vue.prototype.$atlasAPI.getUser = () => {
            const decoded = Vue.prototype.$atlasAPI.decodeToken();
            return axiosJWTAuth.get(`/users/${decoded.userId}`);
        };
    },
};

export default AtlasAPI;